exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:KaushanScript;src:url(" + require("../../../assets/KaushanScript-Regular.ttf") + ") format(\"truetype\");font-weight:400;font-style:normal}#typed-signature-box{color:#000!important;font:normal 1.875em/50px KaushanScript,Georgia,Times,serif;margin-bottom:20px;font-size:2.5em}.signature-text{text-align:center}.signature-text .signature{width:100%;height:36px;font-family:KaushanScript;font-size:25px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#000;margin:auto}.signature-text #typed-signature{width:241.5px;height:36px;border-radius:2px;background-color:#fff;background-color:var(--white);border:2px solid #cfcfd2;margin:auto}.signature-text a{font-size:12px;color:#3ec19d;bottom:-15px;font-weight:600;font-style:normal;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./directives/freeforms/signatureText/signatureText.scss
// module id = 358
// module chunks = 0